export const CONTACT_SEND_REQUEST = "CONTACT_SEND_REQUEST";
export const CONTACT_SEND_SUCCESS = "CONTACT_SEND_SUCCESS";
export const CONTACT_SEND_FAIL = "CONTACT_SEND_FAIL";
